export const FirstCompBar = {


    layout: {
        padding: {
            top: 0,
            bottom: 0,
        },
    },
    legend: {
        display: false
    },

    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',

        },
        legend: {
            display: false
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false,
                color: '#1b4b7b',
                zeroLineColors: '#1b4b7b',
                // borderDash : [5,5]
            },
            barThickness: 20,
            ticks: {
                autoSkip: false,
                fontStyle: 'bold',
                fontSize: '12',
                fontColor: '#1b4b7b',
            }
        }],

        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false,
                color: '#1b4b7b',
                zeroLineColors: '#1b4b7b',
                // borderDash : [5,5]
            },
            ticks: {
                beginAtZero: true,
                fontStyle: 'bold',
                fontSize: '12',
                fontColor: '#1b4b7b',
            }
        }]
    }
}



export const SecondPieChart= {


    layout: {
        padding: {
            top: 0,
            bottom: 0,
        },
    },
    legend: {
        display: false
    },

    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',

        },
        legend: {
            display: false
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

   
}


export const ThirdPieChart= {


    layout: {
        padding: {
            top: 0,
            bottom: 0,
        },
    },
    legend: {
        display: true,
        position:'right'
    },

    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',

        },
        legend: {
            display: false
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

   
}
